import React from 'react';

NotFound.propTypes = {
    
};

function NotFound(props) {
    return (
        <div>
            <h1>Not Found</h1>
        </div>
    );
}

export default NotFound;